import { individualApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async initRiskAssessment({ commit, dispatch }, params = {}) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchDdStates'),
      dispatch('fetchRiskStates'),
      dispatch('fetchSummary'),
      dispatch('fetchUsers', params),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchDdStates({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestCddEddState(token);
      commit('setDdStates', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchRiskStates({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestRiskAssessmentState(token);
      commit('setRiskStates', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchSummary({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestRiskAssessmentSummary(token);
      commit('setSummary', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async incrementUsers({ commit, dispatch }, params) {
    commit('setAdding', true);
    await dispatch('fetchUsers', params);
    commit('setAdding', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async refreshUsers({ commit, dispatch }, params) {
    commit('setRefreshing', true);
    commit('setUsers', []);
    await dispatch('fetchUsers', params);
    commit('setRefreshing', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {Object} params
   */
  async fetchUsers({ commit, rootGetters }, params = {}) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestRiskAssessmentList(
        token,
        params,
      );
      if (response.data.result && response.data.result.length > 0) {
        commit('addUsers', response.data.result);
      }
      commit('setPaging', response.data.paging);
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
